import setLaterSuitabilityState from './setLaterSuitabilityState'

const resolvers = {
  setLaterSuitabilityState,
}

export default resolvers
